<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12">
            <div class="card">                
                <div class="card-body">
                    <div v-if="isBusy" class="text-center text-danger space">
                        <b-spinner class="align-middle"></b-spinner>
                    </div>
                    
                    <template v-if="!isBusy">
                    <b-row>
                        <b-col cols="6">
                            <b-form-group label="RUT" label-for="rut-input">
                                <b-form-input
                                    :disabled="disabled"
                                    id="rut-input"
                                    :value="rutInput">
                                </b-form-input>
                            </b-form-group>
                            <b-form-group label="Dirección facturación" label-for="dir-input">
                                <b-form-input 
                                    :disabled="disabled"
                                    id="dir-input"
                                    :value="dirInput">
                                </b-form-input>
                            </b-form-group>
                            <b-form-group label="Comuna" label-for="com-input">
                                <b-form-input
                                    :disabled="disabled"
                                    id="com-input"
                                    :value="comInput">
                                </b-form-input>
                            </b-form-group>
                            <b-form-group label="Teléfono" label-for="tel-input">
                                <b-form-input 
                                    :disabled="disabled"
                                    id="tel-input"
                                    :value="telInput">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group label="Nombre" label-for="nom-input">
                                <b-form-input 
                                    :disabled="disabled"
                                    id="nom-input"
                                    :value="nomInput">
                                </b-form-input>
                            </b-form-group>
                            <b-form-group label="Giro" label-for="gir-input">
                                <b-form-input 
                                    :disabled="disabled"
                                    id="gir-input"
                                    :value="girInput">
                                </b-form-input>
                            </b-form-group>
                            <b-form-group label="Ciudad" label-for="ciu-input">
                                <b-form-input 
                                    :disabled="disabled"
                                    id="ciu-input"
                                    :value="this.ciuInput">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row class="mt-3" v-if="ejecutivoCobranza.length > 0">
                        <b-col cols="12">
                            <h5>DATOS DE EJECUTIVO DE COBRANZAS:</h5>
                        </b-col>                        
                    </b-row>
                    <b-row v-for="ejecutivo in ejecutivoCobranza" :key="ejecutivo.id">
                        <b-col cols="3">
                            <b>Nombre:</b> {{ejecutivo.nombre}}
                        </b-col>
                        <b-col cols="3">
                            <b>Teléfono:</b> {{ejecutivo.telefono}}
                        </b-col>
                        <b-col cols="3">
                            <b>Correo:</b> {{ejecutivo.correo}}
                        </b-col>
                        <b-col cols="3">
                            <b>Sucursal:</b> {{ejecutivo.sucursal}}
                        </b-col> 
                    </b-row>

                    <b-row class="mt-3" v-if="ejecutivoLeasing.length > 0">
                        <b-col cols="12">
                            <h5>DATOS DE EJECUTIVO DE LEASING:</h5>
                        </b-col>                        
                    </b-row>
                    <b-row v-for="ejecutivo in ejecutivoLeasing" :key="ejecutivo.id">
                        <b-col cols="3">
                            <b>Nombre:</b> {{ejecutivo.nombre}}
                        </b-col>
                        <b-col cols="3">
                            <b>Teléfono:</b> {{ejecutivo.telefono}}
                        </b-col>
                        <b-col cols="3">
                            <b>Correo:</b> {{ejecutivo.correo}}
                        </b-col>
                        <b-col cols="3">
                            <b>Sucursal:</b> {{ejecutivo.sucursal}}
                        </b-col> 
                    </b-row>

                    <b-row class="mt-3" v-if="coordinadorLeasing.length > 0">
                        <b-col cols="12">
                            <h5>DATOS DE COORDINADOR DE CONTRATOS LEASING:</h5>
                        </b-col>                        
                    </b-row>
                    <b-row v-for="ejecutivo in coordinadorLeasing" :key="ejecutivo.id">
                        <b-col cols="3">
                            <b>Nombre:</b> {{ejecutivo.nombre}}
                        </b-col>
                        <b-col cols="3">
                            <b>Teléfono:</b> {{ejecutivo.telefono}}
                        </b-col>
                        <b-col cols="3">
                            <b>Correo:</b> {{ejecutivo.correo}}
                        </b-col>
                        <b-col cols="3">
                            <b>Sucursal:</b> {{ejecutivo.sucursal}}
                        </b-col> 
                    </b-row>       
                    </template>
                </div>
            </div>        
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../../router/layouts/main";
import PageHeader from "@/components/page-header";
import axios from "@/axios";

export default {
    data(){
        return{
            rut: this.$route.query.id,
            title: "empresa",
            rutInput: "",
            dirInput: "",
            comInput: "",
            telInput: "",
            nomInput: "",
            girInput: "",
            ciuInput: "",
            ejecutivoCobranza: [],
            ejecutivoLeasing: [],
            coordinadorLeasing: [],
            disabled: true,
            items: [],
            isBusy: false
        }
    },
    components: { Layout, PageHeader},
    mounted(){
        this.getData();
    },
    methods:{
        getData(){
            this.isBusy = true;
             Promise.all([                
                axios.get(`GetEjecutivoCobranza/${this.$route.params.id}`), 
                axios.get(`GetEjecutivosLeasing/${this.$route.params.id}`),
                axios.get(`GetCoordinadoresLeasing/${this.$route.params.id}`),
                axios.get('/GetEmpresasByContacto',{ params: {rutContacto: this.formatRutcontacto()} } )
            ])
                .then(([cobranza, leasing, coordLeasing, empresas]) => {
                    //Datos de la empresa
                    empresas.data.datos.map((item)=>{
                        if(item.rutEmpresa == this.$route.params.id){
                            this.rutInput = item.rutEmpresa;
                            this.dirInput = item.direccionFacturacion;
                            this.comInput = item.comuna;
                            this.telInput = item.telefono;
                            this.nomInput = item.nombre;
                            this.girInput = item.giro;
                            this.ciuInput = item.ciudad;
                        }
                    });
                    //Datos del ejecutivo de Cobranzas
                    this.ejecutivoCobranza = cobranza.data ? cobranza.data : [];
                    //Datos del ejecutivo de Leasing
                    this.ejecutivoLeasing = leasing.data ? leasing.data : [];
                    //Datos del coordinador de Leasing
                    this.coordinadorLeasing = coordLeasing.data ? coordLeasing.data : [];

                    this.isBusy = false;            
                })
                .catch(() => {
                    this.$bvToast.toast(
                        'No se pudieron recuperar alguno de los datos de la empresa.',
                        {
                        title: this.$t("lease.request.error.nonFound").toString(),
                        variant: "danger",
                        solid: true,
                        }
                    );
                    this.isBusy = false;
                    }
                );   
        },
        formatRutcontacto(){
            let dividida = this.$store.getters["auth/contacto"].identificador.split("-");
            return dividida[0];
        }
    }
}
</script>

<style scoped>
.form-group {
    margin-bottom: 0.5rem !important;
}
h5{
    color: black;
}
</style>